import { render, staticRenderFns } from "./EditBusinessUnits.vue?vue&type=template&id=47e1678c&"
import script from "./EditBusinessUnits.vue?vue&type=script&lang=js&"
export * from "./EditBusinessUnits.vue?vue&type=script&lang=js&"
import style0 from "./EditBusinessUnits.vue?vue&type=style&index=0&id=47e1678c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports